import React, { useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useHistory } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import { IconContext } from "react-icons/lib";
// import { WEB_URL } from ".././../constants/Global";
import Nevlogo from "../../../assets/img/logo.png";
import userdefaultlogo from "../../../assets/img/userlogo.png";
import * as AiIcons from "react-icons/ai";
import * as RiIcons from "react-icons/ri";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useSelector } from "react-redux";
import { WEB_URL } from "../.././../constants/Global";

const TopNav = styled.div`
  background: #fff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 15px;
  z-index: 999999;
  clear: both;

  @media (min-width: 767px) {
    position: fixed;
    left: 0%;
    width: 100%;
  }
`;

const TopNavInner = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  margin-top: 25px;
  @media (min-width: 767px) {
    width: 96%;
    margin: auto;
  }
`;

const Nav = styled.div`
  background: #186cc2;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const Navnew = styled.div`
  background: #15171c;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  float: right;
  left: 70px;
  text-transform: uppercase;
  top: 0px;
  color: #fff;
`;

const Navright = styled.div`
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-transform: uppercase;
  color: #fff;
`;

const Logo = styled.div`
  padding-left: 10px;
  color: #fff;
  width: 40%;
`;

const NavRight = styled.div`
  padding-left: 10px;
  color: #fff;
  padding-right: 14px;
  width: 53%;
`;

const NavIcon = styled(Link)`
  margin-left: 1rem;
  font-size: 1.8rem;
  height: 60px;
  color: red;
  display: flex;
  justify-content: end;
  align-items: center;
  text-transform: uppercase;
  font-weight: bold;
`;

const SidebarNav = styled.nav`
  /*background: rgba(0,0,0,0.2);*/
  width: 100%;
  height: 100vh;
  /*display: flex;*/
  justify-content: center;
  position: fixed;
  top: 0;
  left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
  transition: 350ms;
  z-index: 10;
`;

const SidebarWrap = styled.div`
  width: 250px;
  height: 100%;
  background: #08498c;
  overflow-y: auto;
`;

const Sidebar = (parm) => {
  const user = JSON.parse(localStorage?.getItem("user")) ? JSON.parse(localStorage?.getItem("user"))[0] : "";

  let title = "test";
  let history = useHistory();

  const loginuser = useSelector((state) => state.setUserlog);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);

  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  // Check if navigation should be hidden
  const hideNavigation = parm.hideNavigation || false;

  function acpgomob() {
    // Build URL with query parameters for GET request
    // const baseUrl = "https://superplayerauction.com/manage/";
    const currentDomain = window.location.origin; 
    const baseUrl = `${currentDomain}/manage/?frnt=1`;
    const params = new URLSearchParams({
      cid: cid,
      aid: 0,
      fkey: token,
      frnt: 1
    });
    const url = `${baseUrl}&${params.toString()}`;
    
    // Open in new tab
    window.open(url, '_blank');
  }
  return (
    <>
      <TopNav className="top-bar">
        {/* Only show top bar if hideNavigation is false */}
        {!hideNavigation && (
          <div className="row res-top">
          <form id="acpformmob" method='get' action="https://superplayerauction.com/manage/" target="_blank">
            <input type="hidden" id="acpmob1" name="cid" />
            <input type="hidden" id="acpmob2" name="aid" />
            <input type="hidden" id="acpmob3" name="fkey" />
            <input type="hidden"  name="frnt" value="1" />
            {/* <input type="hidden" name="loginbyadmin" value="1" /> */}

          </form>
            <div className="col-xs-6 res-top-mob">
              {" "}
              <RiIcons.RiPhoneFill className="top-phone" /> +91 83860-11123
            </div>
            <div className="col-xs-6 res-top-how-to-usec">
              How to use software ?
            </div>
          </div>
        )}

        <TopNavInner>
          <IconContext.Provider value={{ color: "#fff" }}>
            <Logo>

              <a href={WEB_URL}>
                <img src={Nevlogo} className="img-fluid" alt="" />
              </a>

            </Logo>

            <SidebarNav onClick={showSidebar} sidebar={sidebar}>
              <SidebarWrap>
                
                  <Link
                    to="/"
                    className="heading-top"
                    style={{ color: "#186cc2" }}
                  >
                    <div className="header-title">

                      <img
                        src={loginuser['photo'] ? loginuser['photo'] : userdefaultlogo}
                        style={{
                          // width: "50px",
                          // height:"50px",
                          borderRadius: "50%",
                          paddingLeft: "4px",
                          paddingRight: "4px",
                        }}
                      // alt="Avatar"
                      />
                      <p>{user?.cperson}</p>
                    </div>
                  </Link>
               
                {loginuser == "" ? (
                  <Link className="mob-nav" to="/">
                    <div>
                      {" "}
                      <RiIcons.RiUser2Line /> Register/Login
                    </div>
                  </Link>
                ) : (
                  <>
                    <Link className="mob-nav" to="/Dashboard">
                      <div>
                        {" "}
                        <RiIcons.RiUser2Line /> Dashboard
                      </div>
                    </Link>

                    <Link className="mob-nav" to="/new-auction">
                      <div>
                        <RiIcons.RiAddFill /> New Auction
                      </div>
                    </Link>
                    <Link className="mob-nav" to="/my-auction">
                      <div>
                        <RiIcons.RiFileListFill /> My Auction
                      </div>
                    </Link>
                    <Link className="mob-nav" to="/join-auction-code">
                      {" "}
                      <div>
                        {" "}
                        <RiIcons.RiAuctionLine /> Join Auction
                      </div>
                    </Link>
                    <Link className="mob-nav" onClick={acpgomob}>
                      <div>
                        {" "}
                        <RiIcons.RiAdminFill /> Auction Panel
                      </div>
                    </Link>
                    <hr className="myseperator" />

                  </>
                )}


                {/* Only show navigation tabs if hideNavigation is false */}
                {!hideNavigation && (
                  <>
                    {window.location.pathname == "/" ? (
                      <>
                        <AnchorLink className="mob-nav" href={WEB_URL + "#today-auction"}>
                          <div>
                            {" "}
                            <RiIcons.RiGameLine /> Today Auction
                          </div>
                        </AnchorLink>

                        <AnchorLink className="mob-nav" href={WEB_URL + "#upcoming-auction"}>
                          <div>
                            {" "}
                            <RiIcons.RiAuctionLine /> Upcoming Auction
                          </div>
                        </AnchorLink>

                        <AnchorLink className="mob-nav" href={WEB_URL + "#our-clients"}>
                          <div>
                            {" "}
                            <AiIcons.AiOutlineUsergroupAdd /> Clients
                          </div>
                        </AnchorLink>

                        <AnchorLink className="mob-nav" href={WEB_URL + "pricing"}>
                          <div>
                            {" "}
                            <RiIcons.RiPriceTag2Line /> Pricing
                          </div>
                        </AnchorLink>

                        <AnchorLink className="mob-nav" href={WEB_URL + "#contact-us"}>
                          <div>
                            {" "}
                            <AiIcons.AiOutlineContacts /> Contact Us
                          </div>
                        </AnchorLink>
                      </>
                    ) : (
                      <>
                        <a className="mob-nav" href={WEB_URL + "/#today-auction"}>
                          <div>
                            {" "}
                            <RiIcons.RiGameLine /> Today Auction
                          </div>
                        </a>

                        <a className="mob-nav" href={WEB_URL + "/#upcoming-auction"}>
                          <div>
                            {" "}
                            <RiIcons.RiAuctionLine /> Upcoming Auction
                          </div>
                        </a>

                        <a className="mob-nav" href={WEB_URL + "/#our-clients"}>
                          <div>
                            {" "}
                            <AiIcons.AiOutlineUsergroupAdd /> Clients
                          </div>
                        </a>

                        <a className="mob-nav" href={WEB_URL + "/pricing"}>
                          <div>
                            {" "}
                            <RiIcons.RiPriceTag2Line /> Pricing
                          </div>
                        </a>

                        <a className="mob-nav" href={WEB_URL + "/#contact-us"}>
                          <div>
                            {" "}
                            <AiIcons.AiOutlineContacts /> Contact Us
                          </div>
                        </a>
                      </>
                    )}
                  </>
                )}
                {loginuser !== "" &&
                  <>
                    <hr className="myseperator" />
                    <Link className="mob-nav" to="/my-profile">
                      <div>
                        {" "}
                        <RiIcons.RiUser2Line /> Profile
                      </div>
                    </Link>

                    <Link className="mob-nav" to="/Logout">
                      <div>
                        {" "}
                        <RiIcons.RiUser2Line /> Logout
                      </div>
                    </Link>
                  </>
                }


              </SidebarWrap>
            </SidebarNav>

            <NavRight>
              <NavIcon style={{}} to="#" onClick={showSidebar}>
                {sidebar == false ? (
                  <FaIcons.FaBars className="navicon_color" />
                ) : (
                  <FaIcons.FaArrowLeft className="navicon_color" />
                )}
              </NavIcon>
            </NavRight>
          </IconContext.Provider>
        </TopNavInner>
      </TopNav>
    </>
  );
};

export default Sidebar;
